var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return 0 ||
    (_vm.specialOffersEnabled &&
      _vm.specialOffers &&
      _vm.specialOffers.length &&
      (_vm.currentBetSlipState < 2 || _vm.mode === "eligible"))
    ? _c(
        "span",
        {
          staticClass: "special-offers",
          class: [
            _vm.mode,
            "tab-" + _vm.tab,
            { SgpPlus: _vm.isSgpPlus, isSGP: _vm.isSGP }
          ]
        },
        [
          _vm.mode === "offerMode"
            ? _vm._l(_vm.specialOffers, function(offer) {
                return _c(
                  "div",
                  {
                    key: offer.Id + "-" + offer.legsToAdd,
                    staticClass: "offer offerMode",
                    class: [
                      offer.Id,
                      "tab-" + _vm.tab,
                      offer.Id + "-" + offer.legsToAdd,
                      { SgpPlus: _vm.isSgpPlus, isSGP: _vm.isSGP }
                    ]
                  },
                  [
                    _c("div", { class: offer.Id }, [
                      _c("div", { staticClass: "offer-name" }, [
                        _c(
                          "span",
                          { staticClass: "offer-title" },
                          [
                            _c("special-translator", {
                              attrs: { offer: offer, phrId: "offer.title" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "offer-mark" },
                          [
                            _c("special-translator", {
                              attrs: { offer: offer, phrId: "offer.mark" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-badge" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.popInfo(offer)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("info_outline")])],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "offer-info" },
                        [
                          _c("special-translator", {
                            key: "legsToAdd-" + offer.legsToAdd,
                            staticClass: "legs-to-add",
                            attrs: {
                              offer: offer,
                              phrId:
                                "offer.addLeg" +
                                (offer.legsToAdd == 1 ? "" : "s")
                            }
                          }),
                          _vm._v(" "),
                          _c("special-translator", {
                            staticClass: "so-description",
                            attrs: { offer: offer, phrId: "offer.Description" }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "eligible"
            ? _vm._l(_vm.specialOffers, function(offer) {
                return _c(
                  "span",
                  {
                    key: offer.Id + "-" + offer.Amount,
                    staticClass: "offer eligible",
                    class: ["tab-" + _vm.tab, offer.Id + "-" + offer.Amount]
                  },
                  [
                    _c(
                      "span",
                      {
                        class: offer.Id,
                        attrs: { set: [(_vm.bonus = _vm.calcBonus(offer))] }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "bonus-label",
                            class: {
                              noBonusValue: !(
                                !_vm.isForBetPlacement &&
                                offer.Amount &&
                                _vm.bonus
                              )
                            }
                          },
                          [
                            _c("special-translator", {
                              attrs: { offer: offer, phrId: "eligible" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isForBetPlacement && offer.Amount && _vm.bonus
                          ? _c("span", { staticClass: "bonus-value" }, [
                              _vm._v(_vm._s(_vm._f("currency")(_vm.bonus)))
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-special-offer-info",
                persistent: "",
                fullscreen: false
              },
              model: {
                value: _vm.dialogSpecialOfferInfo.active,
                callback: function($$v) {
                  _vm.$set(_vm.dialogSpecialOfferInfo, "active", $$v)
                },
                expression: "dialogSpecialOfferInfo.active"
              }
            },
            [
              _c("special-offer-info", {
                attrs: { dialogSpecialOfferInfo: _vm.dialogSpecialOfferInfo }
              })
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-317a9410", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-317a9410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/SpecialOffers/specialOffersBC.vue
// module id = null
// module chunks = 